// BEE-19: Features section
import { Calendar, CheckSquare, MessageSquare, Activity, Clock, Lock } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

interface Feature {
  icon: LucideIcon
  tile: 'green' | 'gold'
  title: string
  body: string
}

const FEATURES: Feature[] = [
  {
    icon: Calendar,
    tile: 'green',
    title: 'Shared calendar',
    body: 'Coordinate appointments, visits, and meal drop-offs. Everyone sees what\'s coming and can claim what they can cover.',
  },
  {
    icon: CheckSquare,
    tile: 'green',
    title: 'Open needs board',
    body: 'Post rides, dinners, meals, or tasks. Your village can see what\'s needed and jump in to help.',
  },
  {
    icon: MessageSquare,
    tile: 'green',
    title: 'Visit notes & insights',
    body: 'Share updates after each visit. Track mood, appetite, mobility — everyone stays informed.',
  },
  {
    icon: Activity,
    tile: 'gold',
    title: 'Daily pulse',
    body: "See today's snapshot at a glance. Know who's visiting, what's planned, and how they're doing.",
  },
  {
    icon: Clock,
    tile: 'green',
    title: 'Pooled support fund',
    body: 'Contribute to shared expenses like grab bars, prescriptions, or meal services. Track what\'s covered together.',
  },
  {
    icon: Lock,
    tile: 'green',
    title: 'Privacy & control',
    body: "You decide who's in the village and what they can see. Invite-only, secure, and built with care.",
  },
]

const GREEN_TILE = 'bg-[#f3f7f3] border border-[#e8efe9] text-[#2d5a3d]'
const GOLD_TILE  = 'bg-[#faf3e0] border border-[#f0dfa6] text-[#8a6a25]'

export default function Features() {
  return (
    <section id="features" className="py-12 sm:py-16 px-6">
      <div className="max-w-[1240px] mx-auto">

        {/* Section header */}
        <div className="text-center mb-8 sm:mb-12">
          <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-green-700 mb-4">
            Everything you need
          </p>
          <h2 className="font-serif font-semibold text-[40px] tracking-[-0.02em] text-ink leading-[1.1] mb-4">
            Built for caring communities
          </h2>
          <p className="text-[16px] text-[#4a4d47] max-w-[440px] mx-auto leading-relaxed">
            Simple, thoughtful features that help everyone stay connected and contribute.
          </p>
        </div>

        {/* Feature cards — 2 col at 768px+, 1 col below */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {FEATURES.map(({ icon: Icon, tile, title, body }) => (
            <div
              key={title}
              className="bg-card border border-[#e8e3d6] rounded-[16px] p-6 shadow-card flex items-start gap-4"
            >
              {/* Icon tile */}
              <div className={`w-9 h-9 rounded-[10px] flex items-center justify-center flex-none mt-0.5 ${tile === 'gold' ? GOLD_TILE : GREEN_TILE}`}>
                <Icon size={17} aria-hidden="true" />
              </div>

              <div>
                <h3 className="font-sans font-semibold text-[15px] text-ink mb-1">
                  {title}
                </h3>
                <p className="text-[13.5px] text-[#4a4d47] leading-relaxed">
                  {body}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  )
}
